<template>
  <div
    dir="rtl"
    :class="{
      printMe: permissions.print_fatwora_client == 1 || user.type == 1
    }"
  >
    <!-- <button @click="print" ><v-icon>print</v-icon></button> -->
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <router-link
      :to="
        '/PrintClientAccount?id=' +
          select_client.id +
          '&from=' +
          date_from +
          '&to=' +
          date_to
      "
      target="_blank"
    >
      <v-icon>print</v-icon>
    </router-link>
    <v-container>
      <v-layout wrap="">
        <img
          style="display:none"
          src="../../../public/images/color.png"
          alt=""
        />
        <v-flex xs12 sm12 md12>
          <p style="font-size:18px">
            <b
              ><u
                >كشف حساب عميل {{ select_client.name }} مختصر من تاريخ
                {{ date_from }} لتاريخ {{ date_to }}</u
              >
            </b>
          </p>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            @keyup.enter="search_client_by_code"
            v-model="searchClientCode"
            label="كودالعميل"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm6 md3>
          <v-autocomplete
            v-model="select_client"
            :items="clients"
            :hint="
              `${
                select_client.mandob_sales
                  ? select_client.mandob_sales.name
                  : ''
              }- ${select_client.mohafza ? select_client.mohafza.name : ''}- ${
                select_client.city ? select_client.city.name : ''
              }- ${select_client.region ? select_client.region.name : ''}- ${
                select_client.branch ? select_client.branch.name : ''
              }`
            "
            item-text="name"
            item-value="id"
            label="أختر العميل"
            persistent-hint
            return-object
            single-line
            @change="get_all_info"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            disabled
            v-model="select_client.rasid_efttahi"
            label="الرصيد الافتتاحي"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_from"
            v-model="modal_from"
            :return-value.sync="date_from"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_from"
                label="تاريخ من"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_from" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_from = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.dialog_from.save(date_from)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_to"
            v-model="modal_to"
            :return-value.sync="date_to"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_to"
                label="تاريخ الي"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_to" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_to = false"
                >Cancel</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dialog_to.save(date_to)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>

        <v-flex xs12 sm6 md1>
          <v-btn @click="get_data">Add</v-btn>
        </v-flex>

        <br />
        <v-flex xs12 sm6 md4 style="font-size:20px"
          ><b>مجموع الخصومات: </b> {{ fatwora_discount_total }}</v-flex
        >
        <v-flex xs12 sm6 md4 style="font-size:20px"
          ><b>مجموع المبيعات : </b> {{ fatwora_price_total }}</v-flex
        >
        <!-- <v-flex xs12 sm6 md4 style="font-size:20px"><b>مجموع المتبقي: </b> {{ fatwora_remain_total }}</v-flex> -->
        <v-flex xs12 sm6 md4 style="font-size:20px"
          ><b>مجموع المرتجعات: </b> {{ reback_price_total }}</v-flex
        >
        <v-flex xs12 sm6 md4 style="font-size:20px"
          ><b>مجموع السدادات: </b> {{ sadad_total }}</v-flex
        >
        <v-flex xs12 sm6 md4 style="font-size:20px"
          ><b> المديونية الحالية: </b> {{ the_madionia }}</v-flex
        >
      </v-layout>

      <div v-if="fatworas.length > 0">فواتير المبيعات</div>
      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.discount }}</td>
          <td class="text-xs-right">{{ props.item.price_before }}</td>
          <td class="text-xs-right">{{ props.item.price_after }}</td>
          <td class="text-xs-right">{{ props.item.remain }}</td>
          <td class="text-xs-right">{{ props.item.sdad_type_name }}</td>
          <td class="text-xs-right">{{ props.item.sdad_status }}</td>
          <td class="text-xs-right">
            {{ props.item.emp_sales_response_name }}
          </td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مبيعات</div>

      <div v-if="rebacks.length > 0">فواتير المرتجعات</div>
      <v-data-table
        :headers="headers2"
        :items="rebacks"
        class="elevation-1"
        v-if="rebacks.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.reback_discount }}</td>
          <td class="text-xs-right">{{ props.item.price_before }}</td>
          <td class="text-xs-right">{{ props.item.price_after }}</td>
          <td class="text-xs-right">
            {{ props.item.emp_sales_response_name }}
          </td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مرتجعات</div>

      <div v-if="khasms.length > 0">فواتير الخصومات</div>
      <v-data-table
        :headers="headers3"
        :items="khasms"
        class="elevation-1"
        v-if="khasms.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-right">{{ props.item.money }}</td>
          <td class="text-xs-right">{{ props.item.note }}</td>
          <td class="text-xs-right">
            {{
              props.item.type == "global"
                ? "خصم علي المديونية"
                : "خصم من فاتورة معينة"
            }}
          </td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير خصومات</div>

      <div v-if="sadads.length > 0">فواتير السدادات</div>
      <v-data-table
        :headers="headers4"
        :items="sadads"
        class="elevation-1"
        v-if="sadads.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-right">{{ props.item.money_q }}</td>
          <td class="text-xs-right">{{ props.item.note }}</td>
          <td class="text-xs-right">{{ props.item.emp_name }}</td>
          <td class="text-xs-right">{{ props.item.khazna_fatwora.code }}</td>
          <td class="text-xs-right">{{ props.item.khazna.name }}</td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير سدادات</div>

      <div v-if="cheques.length > 0">الشيكات</div>
      <v-data-table
        :headers="headers8"
        :items="cheques"
        class="elevation-1"
        v-if="cheques.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '1'
                ? { 'background-color': 'yellow' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td>
              <img
                style="width:100px;height:100px"
                :src="appUrl + 'cheques/' + props.item.cheque_photos"
                alt=""
              />
            </td>
            <td class="text-xs-right">{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.value }}</td>
            <td class="text-xs-right">{{ props.item.date_sadad }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">
              {{ props.item.status == "1" ? "لم يدفع" : "مدفوع" }}
            </td>
            <td class="text-xs-right">
              {{ props.item.bank_deposit ? props.item.bank_deposit.name : "" }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.bank_withdrew ? props.item.bank_withdrew.name : ""
              }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <div v-else>لا يوجد شيكات</div>
    </v-container>

    <div
      id="printMe"
      style="width:100%;direction:rtl;text-align: right;display:none"
    >
      <div
        style="-webkit-box-flex: 1;-ms-flex: 1 1 100%;flex: 1 1 100%;margin: auto;padding: 24px;width: 100%;    max-width: 1185px;direction: rtl;text-align: right;padding:15px"
      >
        <div
          style="flex-wrap: wrap;direction: rtl;display: flex;-webkit-box-flex: 1;padding-bottom:30px;"
        >
          <div
            style="flex-basis: 30%;-webkit-box-flex: 0;flex-grow: 0;max-width: 30%;direction: rtl;text-align:center;"
          >
            <img
              style="width:200px;height:160px;direction: rtl;"
              src="../../../public/images/color.png"
              alt=""
            />
          </div>
          <div
            style="flex-basis: 70%;-webkit-box-flex: 0;flex-grow: 0;max-width: 70%;text-align:center;border-right:1px solid #aaa;direction: rtl;"
          >
            <p
              style="font-size: 30px;text-decoration: underline;margin-bottom: 0px"
            >
              كشف حساب عميل {{ select_client.name }} مختصر <br />
              من تاريخ {{ date_from }} لتاريخ {{ date_to }}
            </p>
            <br />
            <p style="margin:0px">
              <b>كود العميل : </b> {{ select_client.code }}
            </p>
            <p style="margin:0px">
              <b> الرصيد الافتتاحي : </b>{{ select_client.rasid_efttahi }}
            </p>
            <p style="margin:0px">
              <b> الحد الائتماني : </b>{{ select_client.had_eetmani }}
            </p>
          </div>
        </div>
        <hr />
        <hr />

        <div
          v-if="fatworas.length > 0"
          style="flex-wrap: wrap;direction: rtl;display: flex;-webkit-box-flex: 1;"
        >
          فواتير المبيعات
          <div
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;max-width: 100%;direction: rtl;text-align:center;border-bottom:2px solid;"
          >
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width: 8%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              الكود
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width: 8%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              الخصم
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width: 8%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              السعر قبل
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width: 8%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              السعر بعد
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width: 8%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              المتبقي
            </p>
            <p
              style="flex-basis: 10%;-webkit-box-flex: 0;flex-grow: 0;max-width: 10%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              نوع السداد
            </p>
            <p
              style="flex-basis: 10%;-webkit-box-flex: 0;flex-grow: 0;max-width: 10%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              حالة السداد
            </p>
            <p
              style="flex-basis: 10%;-webkit-box-flex: 0;flex-grow: 0;max-width: 10%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              المندوب
            </p>
            <p
              style="flex-basis: 13%;-webkit-box-flex: 0;flex-grow: 0;max-width: 13%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              التاريخ
            </p>
            <p
              style="flex-basis: 13%;-webkit-box-flex: 0;flex-grow: 0;max-width: 13%;direction: rtl;text-align:center;margin:0px;padding:20px;font-weight:bold;"
            >
              تاريخ التسليم
            </p>
          </div>

          <div
            v-for="(f, i) in fatworas"
            :key="i"
            :style="[
              i % 2 == 0
                ? { 'background-color': '#ccc' }
                : { 'background-color': '#fff' }
            ]"
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;max-width: 100%;direction: rtl;text-align:center;border-bottom:2px solid;"
          >
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width: 8%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              {{ f.code }}
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width: 8%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.discount }}
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width: 8%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.price_before }}
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width: 8%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.price_after }}
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width: 8%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.remain }}
            </p>
            <p
              style="flex-basis: 10%;-webkit-box-flex: 0;flex-grow: 0;max-width: 10%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.sdad_type_name }}
            </p>
            <p
              style="flex-basis: 10%;-webkit-box-flex: 0;flex-grow: 0;max-width: 10%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.sdad_status }}
            </p>
            <p
              style="flex-basis: 10%;-webkit-box-flex: 0;flex-grow: 0;max-width: 10%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.emp_sales_response_name }}
            </p>
            <p
              style="flex-basis: 13%;-webkit-box-flex: 0;flex-grow: 0;max-width: 13%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.created_at.substring(10, -8) }}
            </p>
            <p
              style="flex-basis: 13%;-webkit-box-flex: 0;flex-grow: 0;max-width: 13%;direction: rtl;text-align:center;margin:0px;padding:20px"
            >
              {{ f.taslim_date }}
            </p>
          </div>
        </div>
        <br />
        <br />
        <hr />
        <hr />

        <div
          v-if="rebacks.length > 0"
          style="flex-wrap: wrap;direction: rtl;display: flex;-webkit-box-flex: 1;"
        >
          فواتير المرتجعات
          <div
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;max-width: 100%;direction: rtl;text-align:center;border-bottom:2px solid;"
          >
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              الكود
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              الخصم المرتجع
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              السعر قبل
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              السعر بعد
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              المندوب
            </p>
            <p
              style="flex-basis: 25%;-webkit-box-flex: 0;flex-grow: 0;max-width: 25%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              تاريخ
            </p>
          </div>

          <div
            v-for="(f, i) in rebacks"
            :key="i"
            :style="[
              i % 2 == 0
                ? { 'background-color': '#ccc' }
                : { 'background-color': '#fff' }
            ]"
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;max-width: 100%;direction: rtl;text-align:center;border-bottom:2px solid;"
          >
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              {{ f.code }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.reback_discount }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.price_before }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.price_after }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.emp_sales_response_name }}
            </p>
            <p
              style="flex-basis: 25%;-webkit-box-flex: 0;flex-grow: 0;max-width: 25%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.created_at.substring(10, -8) }}
            </p>
          </div>
        </div>
        <br />
        <br />
        <hr />
        <hr />

        <div
          v-if="khasms.length > 0"
          style="flex-wrap: wrap;direction: rtl;display: flex;-webkit-box-flex: 1;"
        >
          الخصومات
          <div
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;max-width: 100%;direction: rtl;text-align:center;border-bottom:2px solid;"
          >
            <p
              style="flex-basis: 25%;-webkit-box-flex: 0;flex-grow: 0;max-width: 25%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              المبلغ
            </p>
            <p
              style="flex-basis: 25%;-webkit-box-flex: 0;flex-grow: 0;max-width: 25%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              الملاحظة
            </p>
            <p
              style="flex-basis: 25%;-webkit-box-flex: 0;flex-grow: 0;max-width: 25%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              نوعية الخصم
            </p>
            <p
              style="flex-basis: 25%;-webkit-box-flex: 0;flex-grow: 0;max-width: 25%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              التاريخ
            </p>
          </div>

          <div
            v-for="(f, i) in khasms"
            :key="i"
            :style="[
              i % 2 == 0
                ? { 'background-color': '#ccc' }
                : { 'background-color': '#fff' }
            ]"
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;max-width: 100%;direction: rtl;text-align:center;border-bottom:2px solid;"
          >
            <p
              style="flex-basis: 25%;-webkit-box-flex: 0;flex-grow: 0;max-width: 25%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              {{ f.money }}
            </p>
            <p
              style="flex-basis: 25%;-webkit-box-flex: 0;flex-grow: 0;max-width: 25%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.note }}
            </p>
            <p
              style="flex-basis: 25%;-webkit-box-flex: 0;flex-grow: 0;max-width: 25%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{
                f.type == "global" ? "خصم علي المديونية" : "خصم من فاتورة معينة"
              }}
            </p>
            <p
              style="flex-basis: 25%;-webkit-box-flex: 0;flex-grow: 0;max-width: 25%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.created_at.substring(10, -8) }}
            </p>
          </div>
        </div>
        <br />
        <br />
        <hr />
        <hr />

        <div
          v-if="sadads.length > 0"
          style="flex-wrap: wrap;direction: rtl;display: flex;-webkit-box-flex: 1;"
        >
          السدادات
          <div
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;max-width: 100%;direction: rtl;text-align:center;border-bottom:2px solid;"
          >
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              المبلغ
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              الملاحظة
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              الموظف
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              كود فاتورة الخزنة
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              اسم الخزنة
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              التاريخ
            </p>
          </div>

          <div
            v-for="(f, i) in sadads"
            :key="i"
            :style="[
              i % 2 == 0
                ? { 'background-color': '#ccc' }
                : { 'background-color': '#fff' }
            ]"
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;max-width: 100%;direction: rtl;text-align:center;border-bottom:2px solid;"
          >
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;font-weight:bold;"
            >
              {{ f.money_q }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.note }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.emp_name }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.khazna_fatwora.code }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.khazna.name }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:2px dotted;"
            >
              {{ f.created_at.substring(10, -8) }}
            </p>
          </div>
        </div>
        <br />
        <br />
        <hr />
        <hr />
        <hr />

        <div
          v-if="sadads.length > 0"
          style="flex-wrap: wrap;direction: rtl;display: flex;-webkit-box-flex: 1;"
        >
          المجموع
          <div
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;max-width: 100%;direction: rtl;text-align:center;border-bottom:2px dotted;"
          >
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;font-weight:bold;"
            >
              الخصومات
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;font-weight:bold;"
            >
              الفواتير
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;font-weight:bold;"
            >
              المتبقي
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;font-weight:bold;"
            >
              المرتجعات
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;font-weight:bold;"
            >
              السدادات
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;font-weight:bold;"
            >
              المديونية
            </p>
          </div>

          <div
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;max-width: 100%;direction: rtl;text-align:center;border-bottom:4px dotted;"
          >
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;font-weight:bold;"
            >
              {{ fatwora_discount_total }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;"
            >
              {{ fatwora_price_total }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;"
            >
              {{ fatwora_remain_total }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;"
            >
              {{ reback_price_total }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;"
            >
              {{ sadad_total }}
            </p>
            <p
              style="flex-basis: 15%;-webkit-box-flex: 0;flex-grow: 0;max-width: 15%;direction: rtl;text-align:center;margin:0px;padding:20px;border-left:3px dotted;"
            >
              {{ the_madionia }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  clients,
  search_client_by_code,
  khazna_fatworas,
  ClientDetailAccount
} from "../config/apiRoute.js";
import { appUrl } from "../config/apiConfig.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      { text: " الكود", align: "right", value: "name", sortable: false },
      { text: " الخصم", value: "address", sortable: false, align: "right" },
      { text: " السعر قبل", value: "rasid", sortable: false, align: "right" },
      { text: " السعر بعد", value: "rasid", sortable: false, align: "right" },
      { text: " المتبقي", value: "address", sortable: false, align: "right" },
      {
        text: " نوع السداد",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: " حالة السداد ",
        value: "control",
        sortable: false,
        align: "center"
      },
      { text: " المندوب", value: "control", sortable: false, align: "center" },
      { text: " التاريخ ", value: "control", sortable: false, align: "center" }
    ],
    headers2: [
      { text: " الكود", align: "right", value: "name", sortable: false },
      {
        text: " الخصم المرتجع",
        value: "address",
        sortable: false,
        align: "right"
      },
      { text: " السعر قبل", value: "rasid", sortable: false, align: "right" },
      { text: " السعر بعد", value: "rasid", sortable: false, align: "right" },
      { text: " المندوب", value: "rasid", sortable: false, align: "right" },
      { text: " التاريخ ", value: "control", sortable: false, align: "center" }
    ],

    headers5: [
      { text: " الصنف", align: "right", value: "name", sortable: false },
      { text: " العدد", value: "address", sortable: false, align: "right" },

      {
        text: "السعر النهائي",
        value: "control",
        sortable: false,
        align: "center"
      }
    ],
    headers6: [
      { text: " الصنف", align: "right", value: "name", sortable: false },
      {
        text: " العدد الاصلي",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " العدد المرتجع",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " العدد المتبقي",
        value: "address",
        sortable: false,
        align: "right"
      },
      { text: "البونص", value: "rasid", sortable: false, align: "right" },
      {
        text: "العدد النهائي",
        value: "rasid",
        sortable: false,
        align: "right"
      },
      { text: " الخصم", value: "address", sortable: false, align: "right" },
      {
        text: "السعر",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: "السعر النهائي",
        value: "control",
        sortable: false,
        align: "center"
      }
    ],
    select_client: { id: "" },
    select_khazna: { id: "" },
    search: "",
    comment: "",
    loading: true,
    rowsPerPageItems: [400, 800],
    detail_dialog: false,
    detail_dialog_reback: false,
    item_detail: {},
    item_detail_reback: {},

    khazina_fatworas: [],
    clients: [],
    fatworas: [],
    khazinas: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    money: "",
    searchClientCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: "",
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    modal_to: false,
    modal_from: false,
    rebacks: [],
    madionias: [],
    sadads: [],
    khasms: [],
    cheques: [],
    fatwora_price_total: "",
    fatwora_remain_total: "",
    reback_price_total: "",
    madionia_last: "",
    sadad_total: "",
    fatwora_discount_total: "",
    output: null,
    the_madionia: 0,
    appUrl: 0
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.appUrl = appUrl;
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      clients().then(response => {
        this.clients = response.data;
        this.loading = false;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });
    },
    print() {
      this.$htmlToPaper("printMe");
    },
    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_client = response.data;
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_client.code;
    },

    detailItem(order) {
      this.item_detail = order;
    },

    detailItem_reback(order) {
      this.item_detail_reback = order;
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    get_data() {
      if (this.select_client.id != "") {
        this.loading = true;
        var frmData = new FormData();
        frmData.append("client_id", this.select_client.id);
        frmData.append("date_from", this.date_from);
        frmData.append("date_to", this.date_to);
        ClientDetailAccount(frmData).then(response => {
          response.data.fatworas.length > 0
            ? (this.fatworas = response.data.fatworas)
            : (this.fatworas = []);
          response.data.rebacks.length > 0
            ? (this.rebacks = response.data.rebacks)
            : (this.rebacks = []);
          response.data.sadads.length > 0
            ? (this.sadads = response.data.sadads)
            : (this.sadads = []);
          response.data.khasms.length > 0
            ? (this.khasms = response.data.khasms)
            : (this.khasms = []);
          response.data.cheques.length > 0
            ? (this.cheques = response.data.cheques)
            : (this.cheques = []);
          this.fatwora_price_total = response.data.fatwora_price_total;
          this.fatwora_remain_total = response.data.fatwora_remain_total;
          this.reback_price_total = response.data.reback_price_total;
          this.the_madionia = response.data.madionia;
          this.sadad_total = response.data.sadad_total;
          this.fatwora_discount_total = response.data.fatwora_discount_total;

          this.loading = false;
        });
      }
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }
  .printMe,
  .printMe * {
    visibility: visible;
  }
  .printMe {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
